import { render, staticRenderFns } from "./NfcIdSet.vue?vue&type=template&id=45d5c2f3&"
import script from "./NfcIdSet.vue?vue&type=script&lang=ts&"
export * from "./NfcIdSet.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports